import React from "react";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter } from "react-router-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./reducer/index";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import * as ReactDOMClient from "react-dom/client";
import "./fonts/Inter-Regular.ttf";
import "./fonts/Bespoke.ttf";
import LoaderProvider from "./provider/PricingLoaderProvider";

const persistConfig = {
  key: "root",
  storage,
  /* Telling the persistor to only persist the products reducer. */
  whitelist: ["productsForSearch", "taxList", "settings"], // only products will be persisted
  // Bump this version whenever a persisted shape (settings/taxList) changes
  // incompatibly, to auto-discard stale localStorage instead of crashing on render.
  version: 1,
  migrate: () => Promise.resolve(undefined),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
let store = createStore(persistedReducer);
let persistor = persistStore(store);

const container = document.getElementById("root");

const root = ReactDOMClient.createRoot(container);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <LoaderProvider>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <HashRouter>
          <App />
        </HashRouter>
      </PersistGate>
    </LoaderProvider>
  </Provider>
  // </React.StrictMode>
);
